import { Component } from "react";
import { Flex, Box } from "@chakra-ui/react";
import { throttle } from "throttle-debounce";
import SvgContainer from "src/components/SvgContainer";
import { withParentStation } from "src/modules/parent-station/ParentStation/Context";
import { ReactComponent as IntensityIcon } from "./afternoon.svg";
import Slider from "src/components/Slider";

class FlashlightIntensitySetter extends Component {
  state = {
    intensity: -1
  };

  componentDidUpdate(prevProps, prevState) {
    const { primaryStation } = this.props.parentStation;
    const { flashlightIntensity } = primaryStation.cameraAndFlashlightState;
    const prevIntensity = prevProps.parentStation.primaryStation.cameraAndFlashlightState.flashlightIntensity;
    if (
      (flashlightIntensity !== prevIntensity && flashlightIntensity !== this.state.intensity) ||
      this.state.intensity === -1
    ) {
      this.setState({ intensity: flashlightIntensity });
    }
  }

  componentDidMount() {
    const initialSensitivity = this.props.parentStation.primaryStation?.cameraAndFlashlightState?.flashlightIntensity;
    if (initialSensitivity) this.setState({ intensity: initialSensitivity });
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { primaryStation } = this.props.parentStation;
    const { cameraAndFlashlightState, mode } = primaryStation;
    return nextProps.parentStation.cameraAndFlashlightState !== cameraAndFlashlightState || nextProps.mode !== mode;
  }

  onChange = (intensity) => {
    this.updateLocalState(intensity);
    this.updateGlobalState(intensity);
  };
  onChangeCommitted = (intensity) => {
    const { flashlightManager } = this.props.parentStation.primaryStation;
    flashlightManager.setIntensity(intensity);
  };

  updateGlobalState = throttle(500, (intensity) => {
    const { flashlightManager } = this.props.parentStation.primaryStation;
    if (flashlightManager.intensity === intensity) return;
    flashlightManager.setIntensity(intensity);
  });
  updateLocalState = throttle(150, (intensity) => {
    if (this.state.intensity === intensity) return;
    this.setState({ intensity });
  });
  render() {
    const { intensity } = this.state;
    const { primaryStation } = this.props.parentStation;
    const { cameraAndFlashlightState, mode } = primaryStation;
    if (
      mode === "audio" ||
      cameraAndFlashlightState.flashlightAdjustable === false ||
      cameraAndFlashlightState.flashlightEnabled === false ||
      intensity === -1
    ) {
      return null;
    }

    return (
      <Flex
        flexDirection="column"
        alignItems="center"
        mt={["35px", "38px", "40px"]}
        transform="translateY(-50%)"
        position="fixed"
        left="14px"
        top="calc(50%)"
      >
        <SvgContainer mb="10px" icon={IntensityIcon} fill="white" size="16px" />
        <Box height="133px">
          <Slider
            value={intensity}
            orientation="vertical"
            onChangeEnd={this.onChangeCommitted}
            onChange={this.onChange}
            min={0}
            max={1}
            props={{
              h: "133px",
              defaultValue: intensity
            }}
            step={0.01}
          />
        </Box>
        <SvgContainer mt="10px" icon={IntensityIcon} fill="white" size="12px" />
      </Flex>
    );
  }
}

export default withParentStation(FlashlightIntensitySetter);
